import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Collapse } from '@material-ui/core';
import ChevronUp from 'mdi-material-ui/ChevronUp';
import ChevronDown from 'mdi-material-ui/ChevronDown';
import isEmpty from 'lodash-es/isEmpty';

import { LabelEnum } from 'app/shared/enums';
import {
  selectCarVersionEt,
  selectIsMotorcycle,
} from 'app/store/data/quotation';
import { DictService, Dictionary } from 'app/services/dict.service';
import { useUser } from 'app/shared/hooks/useUser';
import { NewButton } from 'app/components/NewButton';
import { useStyles } from './CarDetailsEtList.styles';

function CarDetailsEtList() {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);
  const [carDetails, setCarDetails] = useState<Dictionary>([]);
  const carVersionEt = useSelector(selectCarVersionEt);
  const { isOperator } = useUser();
  const isMotor = useSelector(selectIsMotorcycle);

  useEffect(() => {
    if (!carVersionEt || isMotor || !isOperator) {
      return;
    }

    const getCarDetails = async () => {
      const { data } = await DictService.getDictionary(
        `car_model_versions/${carVersionEt}/equipment`
      );

      setCarDetails(data);
    };

    getCarDetails();
  }, [carVersionEt, isMotor, isOperator]);

  if (isEmpty(carDetails)) {
    return null;
  }

  return (
    <div className={classes.root}>
      <NewButton
        title={LabelEnum.VersionDetailsEurotax}
        className={classes.btn}
        type="button"
        variant="text"
        color="primary"
        onClick={() => setExpanded(!expanded)}
        endIcon={expanded ? <ChevronUp /> : <ChevronDown />}
        disableRipple
      />
      <Collapse in={expanded}>
        <ul className={classes.list}>
          {carDetails.map(({ key, value }) => (
            <li key={key} className={classes.listItem}>
              {value}
            </li>
          ))}
        </ul>
      </Collapse>
    </div>
  );
}

export default React.memo(CarDetailsEtList);
